import { render, staticRenderFns } from "./ReceiptOrderQuery.vue?vue&type=template&id=6570c84e&scoped=true"
import script from "./ReceiptOrderQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./ReceiptOrderQuery.vue?vue&type=style&index=0&id=6570c84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570c84e",
  null
  
)

export default component.exports